/**
 * Hier kommt Code für die Mitarbeiter Zeiteneingabe hin
 */
import _ from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';
import basedataService from '../services/basedataService.js';
import stammdatenService from '../services/stammdatenService.js';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import {
	checkUrlaubsantragKollisionen,
    fuelleSelectOptionen,
    holePostenMitarbeiter,
    holeEinsatzorteMitarbeiter,
    holeQualifikationenMitarbeiter,
	formatNumber2Decimals,
	ObservableArray,
} from '../util.js';
import { feiertagFilter } from '../../../../util/util.js';
import schichtService from '../services/schichtService.js';
import HoverPopupService, { renderKamerabilderInPopup } from '../services/hoverPopupService.js';
import { Egfz, EgfzBezahlt } from '../../../../shared/services/Egfz.js';
import { ArbeitAmFeiertagTyp } from '../../../../../domain/konstanten/ArbeitAmFeiertagTyp.js';
import StandortMapView from '../standort_map.js';

// Globale Event Listener einbinden
window.myVars = window.myVars || {};
window.myHandlers = window.myHandlers || {};
window.myHandlers.pickDate = pickDate;
window.myHandlers.neuePause = neuePause;
window.myHandlers.inputNavigation = inputNavigation;
window.myHandlers.berechneBezahlteZeit = berechneBezahlteZeit;
window.myHandlers.resetKeysPressedCount = resetKeysPressedCount;
window.myHandlers.berechneEgfzTageAnzahl = berechneEgfzTageAnzahl;
window.myHandlers.inputEgfzTage = inputEgfzTage;
window.myHandlers.jumpNext = jumpNext;
window.myHandlers.showRows = showRows;
window.myHandlers.selectTag = selectTag;
window.myHandlers.inputZeiten = inputZeiten;
window.myHandlers.leseRegelarbeitszeiten = leseRegelarbeitszeiten;
window.myHandlers.monatlicheGutzeitMA = monatlicheGutzeitMA;
window.myHandlers.arbeitszeitenVormonat = arbeitszeitenVormonat;
window.myHandlers.regelarbeitszeitenAnwenden = regelarbeitszeitenAnwenden;
window.myHandlers.toggleStempelZeiten = toggleStempelZeiten;

let zeitenAnsicht = 2;
let stempelZeitenAn = false;
let schichtSelected = null;
// Unternehmenseinstellung "Schicht Bestätigung notwendig" (wird in zeitenScript() geladen)
let bestaetigungNotwendig = false;

let keysPressedCount = 0;
let oldFocus = null;
let schichtenIndex = null;
let deleteStartIndex = null;
let feiertageBundesland = [];
const zeitenMonat = ObservableArray();
// Example callback function
zeitenMonat.setCallback((zeitenNeu) => berechneSummen(zeitenNeu));

// Variablen für die Geolocation Map
let standortMap;
// Gemeinsames Hover-Popup für Kamerabilder + Bestätigen-Button (unbestätigte Schichten)
const kameraPopup = new HoverPopupService('sharedKameraPopup');

function isMultiSelectModifier(event) {
	return event !== null && (event.ctrlKey === true || event.metaKey === true);
}

function suppressMacContextMenu(event) {
	if (!window.myVars.zeitenEditable) {
		return;
	}
	if (event.ctrlKey === true) {
		event.preventDefault();
	}
}

// Führt den initialen Aufruf der Zeitenoberfläche auf und befüllt sie mit den aktuellen Daten.
async function zeitenScript(autoSelect = true) {
	document.body.style.cursor = 'wait';
	if (_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
		return;
	}
	// Mitarbeiter daten refreshen für mögliche Änderungen im Urlaubsantrag usw.
	await stammdatenService.holeMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);

	// Mitarbeiter muss einem Betrieb zuegordnet sein, damit Zeiten erfasst werden können
	const betriebsstaetteID = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].BetriebsstaetteID;
	if (!betriebsstaetteID || betriebsstaetteID === '') {
		const dialogText = 'Dieser Mitarbeiter ist keiner Betriebsstätte zugeordnet! Bitte gehen Sie zum Reiter Beschäftigung und wählen Sie eine aus.';
		document.getElementById('zeiten-alert-text').innerText = dialogText;
		await SystemDialogService.instance.displayAsync('zeiten-alert-dialog');
		return;
	}
	// Relevante Basedata Infos laden
	const aktuelleBS = stammdatenService.unternehmensobjekt.Betriebsstaette.find((bs) => bs._id === betriebsstaetteID);
	const feiertage = await basedataService.holeFeiertageBasedataProvider();
	feiertageBundesland = feiertagFilter(feiertage, aktuelleBS.Bundesland, aktuelleBS.Feiertage);
	const egfz = await basedataService.holeEgfzBasedataProvider();

	// Schicht Bestätigung notwendig? Steuert das Ausgrauen unbestätigter Schichten (Hover-Popup mit Bestätigen-Button)
	bestaetigungNotwendig = Boolean(stammdatenService.unternehmensobjekt.MitarbeiterAppEinstellungen?.SchichtBestaetigungNotwendig);

	// Zeiten Input Elemente
	const zeitenBody = document.getElementById('zeiten-body');
	zeitenBody.removeEventListener('contextmenu', suppressMacContextMenu);
	zeitenBody.addEventListener('contextmenu', suppressMacContextMenu);
	const qualiSelect = zeitenBody.querySelector('[aria-label="zeiten-QualifikationID"]');
	const einsatzortSelect = zeitenBody.querySelector('[aria-label="zeiten-EinsatzortID"]');
	const postenSelect = zeitenBody.querySelector('[aria-label="zeiten-PostenID"]');
	const efgzSelect = zeitenBody.querySelector('[aria-label="zeiten-Egfz"]');
	const qualisMA = holeQualifikationenMitarbeiter();
	const postenMA = holePostenMitarbeiter();
	const einsatzorteMA = holeEinsatzorteMitarbeiter();

	// Qualifikationen können im Mitarbeiterobjekt doppelt vorkommen (verschiedene Gültigkeitszeiträume)
	const seenQualis = {}; // Daher erstellen wir ein Set von Mitarbeiter Qualifikationen
	const filteredQualis = qualisMA.filter((qu) => {
		const id = qu.QualifikationID;
		if (!seenQualis[id]) {
			seenQualis[id] = true;
			return true; // Keep the object if it's the first occurrence of this qualification
		}
		return false; // Filter out objects with the same qualification
	});
	
	// Standardqualifikation als Vorauswahl
	filteredQualis.sort((a, b) => a?.IstStandardQualifikation == b?.IstStandardQualifikation ? 0 : a ? -1 : 1);
	
	// Input Control bestücken
	fuelleSelectOptionen(qualiSelect, filteredQualis, 'QualifikationID', 'Bezeichnung');
	fuelleSelectOptionen(postenSelect, postenMA, 'PostenID', 'Bezeichnung');
	fuelleSelectOptionen(einsatzortSelect, einsatzorteMA, 'EinsatzortID', 'Bezeichnung');
	
	// Wenn es Einsatzorte gibt, dann den ersten automatisch auswählen
	if (einsatzorteMA.length > 1) einsatzortSelect.value = einsatzortSelect.options[1].value;
	fuelleSelectOptionen(efgzSelect, egfz.sort((a, b) => a.Sort - b.Sort), 'EGFZID', 'Bezeichnung');

	// Umsatz Input zurücksetzen und nur anzeigen falls im Mitarbeiter eine Umsatzentlohnung aktiviert ist.
	zeitenBody.querySelector('[aria-label="zeiten-Umsatz"]').value = 0;
	if (stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Verguetung.some((quali) => ['umsatzorientierterStundenlohn', 'Umsatzanteilslohn', 'umsatzorientierterStundenlohnTaeglich', 'UmsatzanteilslohnTaeglich'].includes(quali.Entlohnung) && quali.Verwenden)) {
		zeitenBody.querySelector('#zeiten-input-umsatz').style.display = 'flex';
	} else {
		zeitenBody.querySelector('#zeiten-input-umsatz').style.display = 'none';
	}

	// Für die erstellung des Monatskalender brauchen wir das Start- und Enddatum, sowie die Tage im Monat
	const abrechnungstag = stammdatenService.unternehmensobjekt.Abrechnungstag;
	let startOfMonth = window.myVars.aktuellesMonatsDatum.startOf('month');
	let endOfMonth = window.myVars.aktuellesMonatsDatum.endOf('month');
	let daysInMonth = window.myVars.aktuellesMonatsDatum.daysInMonth();

	// Wenn das Unternehmen ein Abrechnungstag früher hat, dann müssen wir die Zeiten anders anzeigen.
	// Zum Beispiel: Abrechnungstag ist er 15., dann sollte man alle Zeiten vom 16. des Vormonats bis zum 15. des aktuellen Monats anzeigen.
	if (abrechnungstag < 31) {
		startOfMonth = startOfMonth.subtract(1, 'month').add(abrechnungstag, 'days');
		endOfMonth = endOfMonth.startOf('month').add(abrechnungstag - 1, 'days');
		daysInMonth = endOfMonth.diff(startOfMonth, 'day') + 1;
	}

	// Erstelle die Oberfläche für jeden Tag im Monat...
	const list = zeitenBody.querySelector('#zeiten-liste');
	list.style.display = 'none';
	list.nextElementSibling.style.display = 'none';
	list.innerHTML = '';
	let dayCounter = startOfMonth.clone();
	for (let i = 1; i <= daysInMonth; i += 1) {
		erstelleKalenderZeile(list, dayCounter, feiertageBundesland);
		dayCounter = dayCounter.add(1, 'day');
	}
	
	// map init bevor wir Zeiten laden. standordMap muss initialisiert sein für die Events auf den Schichtbalken
	standortMap = new StandortMapView('sharedMapPopup');
	standortMap.initMap();

	// Lade alle Schichten des Monats des Mitarbeiters und zeige sie an...
	const zeiten = await schichtService.leseAlleSchichtenMitarbeiter(startOfMonth.startOf('day').format('YYYY-MM-DD'), endOfMonth.endOf('day').format('YYYY-MM-DD'), stammdatenService.aktuellerMitarbeiter._id);
	zeitenMonat.set(zeiten);
	for (const zeit of zeitenMonat.get()) {
		await erstelleSchichtElement(zeit, true);
	}
	// Damit alles auf einmal erscheint
	list.style.display = 'block';
	list.nextElementSibling.style.display = 'flex';
	// Füge Anfangswerte und HTML Validierungen ein max und min date für Date Picker ein:
	const egfzVonInput = document.querySelector('[aria-label="egfz-von"]');
	egfzVonInput.value = startOfMonth.format('YYYY-MM-DD');
	egfzVonInput.min = startOfMonth.format('YYYY-MM-DD');
	egfzVonInput.max = endOfMonth.format('YYYY-MM-DD');
	
	const egfzBisInput = document.querySelector('[aria-label="egfz-bis"]');
	egfzBisInput.value = startOfMonth.format('YYYY-MM-DD');
	egfzBisInput.min = startOfMonth.format('YYYY-MM-DD');
	egfzBisInput.max = endOfMonth.add(1, 'month').format('YYYY-MM-DD'); // In nächsten Monat erlauben

	const datumInput = document.body.querySelector('#zeiten-datum-input');
	datumInput.min = startOfMonth.format('YYYY-MM-DD');
	datumInput.max = endOfMonth.format('YYYY-MM-DD');

	// Pausenmodell aktiv?
	const pausenmodellCheckbox = document.getElementById('zeiten-pausenmodell-aktiv');
	pausenmodellCheckbox.checked = !_.isEmpty(stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Pausenmodell);
	// Pausenmodell nur schaltbar, falls eins hinterlegt ist
	pausenmodellCheckbox.disabled = _.isEmpty(stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Pausenmodell);
	document.body.style.cursor = 'default';

	// Weitere Funktionen Buttons
	const unternehmen = stammdatenService.unternehmensobjekt;
	const btnSettings = _.pick(unternehmen, ['GZMonatButton', 'VormonatKopierenButton', 'RegelarbeitszeitButton']);
	for (const [key, value] of Object.entries(btnSettings)) {
		const btn = document.querySelector(`[aria-label="wf-${key}"]`);
		btn.disabled = !value;
	}
}

/**
 * Befüllt die Kalender Liste mit einer Zeile inklusive KW, Tagesdatum, Urlaubicons
 * @param {HTMLElement} list HTML Element für die Liste der Kalendertage
 * @param {dayjs} dayCounter dayjs Datum des Tages
 */
function erstelleKalenderZeile(list, dayCounter, feiertageBundesland) {
	// Zeilen Element erstellen
	const item = document.createElement('div');
	item.setAttribute('aria-label', dayCounter.format('YYYY-MM-DD'));
	
	// Klick auf eine Zeile wählt die Schicht an dem Tag aus (falls vorhanden)
	item.addEventListener('click', async (event) => {
		await selectTag(item, event);
	});
	
	// Sonntage farblich markieren
	item.classList.add('zeiten-list-item');
	if (dayCounter.day() === 0) {
		item.classList.add('zeiten-sonntag');
	}
	
	// Feiertage farblich markieren
	const isFeiertag = feiertageBundesland.find((feiertag) => {
		return feiertag.dateFormat == dayCounter.format('DD.MM.YYYY');
	});
	if (isFeiertag) {
		item.classList.add('zeiten-feiertag');
		item.title = isFeiertag.fname;
	}
	// Tage außerhalb der Beschäftigung "ausgrauen"
	const eintritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Eintrittsdatum;
	const austritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Austrittsdatum;
	const isNotActive = (eintritt && dayCounter.format('YYYY-MM-DD') < eintritt)
		|| (austritt && dayCounter.format('YYYY-MM-DD') > austritt);

	if (isNotActive) {
		item.style.opacity = '0.5';
	}
	
	// KW hinzufügen
	const kalWoche = document.createElement('div');
	kalWoche.classList.add('zeiten-kw');
	kalWoche.innerText = dayCounter.add(14, 'hours').isoWeek(); // isoWeek() nimmt local TZ: für Zeitzonen Behandlung addieren wir 14h
	item.appendChild(kalWoche);
	
	// Tag hinzufügen
	const tag = document.createElement('div');
	tag.classList.add('zeiten-tag');
	tag.innerHTML = `<span>${dayCounter.format('dd')}.</span><span> ${dayCounter.format('DD.MM.')}</span>`;
	item.appendChild(tag);

	// Urlaub anzeigen mit Flugzeug Icon (verhindert schicht hinzufügen)
	const urlaubsantraege = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Urlaubsantraege;
	if (!_.isEmpty(urlaubsantraege)) {
		const hatUrlaub = urlaubsantraege.some((ua) => {
			const dayFormat = dayCounter.format('YYYY-MM-DD');
			return ua.UrlaubStatus === 'genehmigt'
				&& dayFormat >= ua.UrlaubVon
				&& dayFormat <= ua.UrlaubBis;
		});
		if (hatUrlaub) {
			const urlaubIcon = document.createElement('i');
			urlaubIcon.className = 'bi bi-airplane-fill tag-urlaub';
			urlaubIcon.title = 'Mitarbeiter ist im Urlaub!';
			item.appendChild(urlaubIcon);
		}
	}
	// Zeile einfügen
	list.appendChild(item);
}

async function berechneSummen(zeiten = []) {
	// Zeitraum Start und Ende (WICHTIG myVars.aktuellesMonatsDatum IST IMMER IN DEUTSCHER ZEITZONE)
	let startOfMonth = window.myVars.aktuellesMonatsDatum.startOf('month');
	let endOfMonth = window.myVars.aktuellesMonatsDatum.endOf('month');
	// Wenn das Unternehmen ein Abrechnungstag früher hat, dann müssen wir die Zeiten anders anzeigen.
	// Zum Beispiel: Abrechnungstag ist er 15., dann sollte man alle Zeiten vom 16. des Vormonats bis zum 15. des aktuellen Monats anzeigen.
	const abrechnungstag = stammdatenService.unternehmensobjekt.Abrechnungstag;
	if (abrechnungstag < 31) {
		startOfMonth = startOfMonth.subtract(1, 'month').add(abrechnungstag, 'days');
		endOfMonth = endOfMonth.startOf('month').add(abrechnungstag - 1, 'days');
	}
	// Zeiten neu laden, falls noch nicht vorhanden
	if (_.isEmpty(zeiten)) {
		zeiten = await schichtService.leseAlleSchichtenMitarbeiter(startOfMonth.startOf('day').format('YYYY-MM-DD'), endOfMonth.endOf('day').format('YYYY-MM-DD'), stammdatenService.aktuellerMitarbeiter._id);
	} else {
		// Falls vorhanden, nach Datum Von sortieren
		zeiten.sort((a, b) => new Date(a.Von) - new Date(b.Von));
	}
	// Wir gehen von 30 Tagen in Monat aus (für die Berechnung der Sollstunden)
	let tage = 30;
	const eintritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Eintrittsdatum;
	let austritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Austrittsdatum;
	// Falls kein austrittsdatum angegeben, zukünftiges Datum wählen...
	if (!austritt) austritt  = '9999-12-01';
	let eintrittDifferenz = 0;
	// Liegt das Eintrittsdatum im Abrechnungszeitraum?
	if (startOfMonth.format('YYYY-MM-DD') < eintritt) {
		eintrittDifferenz = dayjs.tz(eintritt, dayjs.tz.DEFAULT_TZ).diff(startOfMonth, 'days');
	}
	// Liegt das Austrittsdatum im Abrechnungszeitraum?
	let austrittDifferenz = 0;
	if (endOfMonth.format('YYYY-MM-DD') > austritt) {
		austrittDifferenz = dayjs(endOfMonth).diff(dayjs.tz(austritt, dayjs.tz.DEFAULT_TZ), 'days');
	}
	// Eintritt und Austritt Differenzen von den 30 Tagen im Monat abziehen
	tage = tage - eintrittDifferenz - austrittDifferenz;
	
	// gibt es Kind Krank Std?
	let kindKrankStunden = 0;
	// initial alles auf 0
	let summeArbeit = 0, summeBezahlt = 0, summeGesamt = 0, summeGZ = 0, summeKrank = 0, summeUrlaub = 0, summeArbeitTage = 0, summeKostRelevanteTage = 0, summeGesamtTage = 0;
	// Ein Tag zählt als kostrelevant, falls mind. eine Schicht des Tages KostRelevant ist (default true bei Altschichten)
	const tagIstKostRelevant = (datum) => zeiten.some((z) => dayjs(z.Datum).tz().isSame(dayjs(datum).tz(), 'day') && z.KostRelevant !== false);
	let lastArbeitstag = new Date(0);
	let lastUrlaubstag = new Date(0);
	let lastKranktag = new Date(0);
	let lastGesamttag = new Date(0);
	// Aufsummieren der Stunden und Tage
	zeiten.forEach((zeit) => {
		if (zeit.Bis === '') {
			return;
		}
		// Unbestätigte Schichten zählen nicht in die Summen, solange die Bestätigungspflicht aktiv ist.
		if (bestaetigungNotwendig && zeit.Bestaetigt === false) {
			return;
		}
		if (_.values(EgfzBezahlt).includes(zeit.Egfz)) {
			summeBezahlt += zeit.BezahlteStunden;
			// unbezahlte Pausen/Unterbrechungen sollen nicht in die Gesamtstunden...
			summeGesamt += zeit.BezahlteStunden;
		} else {
			// unbezahlte EGFZ Arten kommen in die Gesamtstunden...
			summeGesamt += zeit.GesamtStunden - zeit.PauseUnbezahltStunden;
		}
		if (zeit.Egfz === Egfz.Arbeit) {
			summeArbeit += zeit.BezahlteStunden;
			if (dayjs(lastArbeitstag).tz().isBefore(zeit.Datum, 'day')) {
				summeArbeitTage += 1;
				if (tagIstKostRelevant(zeit.Datum)) summeKostRelevanteTage += 1;
				lastArbeitstag = zeit.Datum;
			}
		}
		if (zeit.Egfz === Egfz.GZAufbau) {
			// GZ Aufbau kann bezahlte Pausen enthalten...
			summeBezahlt += zeit.BezahlteStunden;
			summeGZ += zeit.GesamtStunden - zeit.PauseUnbezahltStunden;
			if (dayjs(lastArbeitstag).tz().isBefore(zeit.Datum, 'day')) {
				summeArbeitTage += 1;
				if (tagIstKostRelevant(zeit.Datum)) summeKostRelevanteTage += 1;
				lastArbeitstag = zeit.Datum;
			}
		}
		// Bei Arbeit am Feiertag zählen auch die arbeisstunden mit und ggfs. GZAufbau
		if (zeit.Egfz === Egfz.ArbeitAmFeiertag) {
			summeArbeit += zeit.BezahlteStunden;
			if (dayjs(lastArbeitstag).tz().isBefore(zeit.Datum, 'day')) {
				summeArbeitTage += 1;
				if (tagIstKostRelevant(zeit.Datum)) summeKostRelevanteTage += 1;
				lastArbeitstag = zeit.Datum;
			}
			if (stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0]?.ArbeitAmFeiertag === ArbeitAmFeiertagTyp.Gutzeit) {
				summeGZ += zeit.BezahlteStunden;
				// Arbeit am FT mit GZ+ zählt doppelt in Gesamtstunden
				summeGesamt += zeit.BezahlteStunden;	
			}
		}
		if (zeit.Egfz === Egfz.GZAbbau) {
			summeGZ -= zeit.GesamtStunden;
		}
		if (zeit.Egfz === Egfz.Urlaub && dayjs(lastUrlaubstag).tz().isBefore(zeit.Datum, 'day')) {
			summeUrlaub += 1;
			lastUrlaubstag = zeit.Datum;
		}
		if ([Egfz.Krank, Egfz.KindKrank, Egfz.Krank6Wochen, Egfz.Krank6Wochen, Egfz.KrankKurzarbeit, Egfz.UnentschuldigtKrank].includes(zeit.Egfz) && dayjs(lastKranktag).tz().isBefore(zeit.Datum, 'day')) {
			summeKrank += 1;
			lastKranktag = zeit.Datum;
			if ([Egfz.KindKrank].includes(zeit.Egfz)) {
				kindKrankStunden += zeit.GesamtStunden;
			}
		}
		if (dayjs(lastGesamttag).tz().isBefore(zeit.Datum, 'day')) {
			if (zeit.Egfz == Egfz.UnbezahltFrei) {
				// unbezahlt frei zählt nicht als Gesamttag wenn 0h
				if (zeit.GesamtStunden > 0) {
					summeGesamtTage += 1;
					lastGesamttag = zeit.Datum;
				}
			} else {
				summeGesamtTage += 1;
				lastGesamttag = zeit.Datum;
			}
		}
	});
	// Summenzeile bestücken
	const summenZeile = document.getElementById('zeiten-liste-summe');
	const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
	summenZeile.querySelector('#ma-zeiten-summe-arbeit').innerText = formatNumber2Decimals(summeArbeit);
	summenZeile.querySelector('#ma-zeiten-summe-bezahlt').innerText = formatNumber2Decimals(summeBezahlt);
	summenZeile.querySelector('#ma-zeiten-summe-gesamt').innerText = formatNumber2Decimals(summeGesamt);
	const sollstundenMonat = tage < 30 ? aktuellerMA.Beschaeftigung[0].SollstundenMonat * tage / 30 : aktuellerMA.Beschaeftigung[0].SollstundenMonat;
	summenZeile.querySelector('#ma-zeiten-summe-soll').innerText = formatNumber2Decimals(sollstundenMonat - kindKrankStunden);
	summenZeile.querySelector('#ma-zeiten-summe-gutzeit').innerText = formatNumber2Decimals(summeGZ);
	summenZeile.querySelector('#ma-zeiten-summe-arbeitstage').innerText = `${summeArbeitTage} (${summeKostRelevanteTage})`;
	summenZeile.querySelector('#ma-zeiten-summe-krank').innerText = summeKrank;
	summenZeile.querySelector('#ma-zeiten-summe-urlaub').innerText = summeUrlaub;
	summenZeile.querySelector('#ma-zeiten-summe-gesamttage').innerText = summeGesamtTage;
}

/**
 * Klappt eine Zeile der Zeitblöcke ein
 * @param {int} rowNumber Nummer der Zeile, die zu verstecken gilt.
 */
function showRows(rowNumber, event = undefined) {
	const liste = document.body.querySelector('#zeiten-liste');
	const checkboxOben = document.getElementById('zeiten-legende-erste-zeile');
	const checkboxUnten = document.getElementById('zeiten-legende-zweite-zeile');
	// Setze beide Häkchen wieder, falls beide Häkchen rausgenommen wurden
	if (!checkboxOben.checked && !checkboxUnten.checked && event) {
		event.preventDefault();
		return;
	}
	// Resette alle Zeilen
	const allRows = liste.querySelectorAll('.zeiten-item');
	allRows.forEach((element) => {
		if (!element.classList.contains('hidden')) {
			element.style.display = 'flex';
		}
	});
	zeitenAnsicht = 0;
	// Verstecke eine Zeile falls nur ein Häkchen rausgenommen wurde...
	if (rowNumber > 0 && (!checkboxOben.checked || !checkboxUnten.checked)) {
		const rows = liste.querySelectorAll(`[aria-rowindex='${rowNumber}'`);
		rows.forEach((element) => {
			element.style.display = 'none';
		});
		zeitenAnsicht = rowNumber;
	}
	liste.classList.toggle('row1-only', zeitenAnsicht === 2);
}

/**
 * Wenn man einen Tag bzw. Schicht in der Liste auswählt, soll das Datum und die Eingaben im Input erscheinen
 * @param {HTMLElement} thisElement das HTML Element auf das geklickt wurde
 * @param {*} event Mögliches Event durch Klick
 */
async function selectTag(thisElement, event = null) {
	// Wenn wir ein Event haben, blockieren wir weitere Events auf das Element
	if (event !== null) event.stopPropagation();
	// Wenn mit Strg/Ctrl auf das Element geklickt wurde, markieren wir es zum Löschen
	if (isMultiSelectModifier(event) && window.myVars.zeitenEditable) {
		removeSchichtSelection();
		if (thisElement.classList.contains('zeiten-grid')) {
			if (thisElement.classList.contains('zeiten-item-loeschen')) {
				thisElement.classList.remove('zeiten-item-loeschen');
				resetDeleteIndices();
			} else {
				thisElement.classList.add('zeiten-item-loeschen');
				const schichten = Array.from(document.querySelectorAll('.zeiten-grid:not(#zeiten-grid-legende)'));
				schichtenIndex = schichten.findIndex((s) => s.id === thisElement.id);
				deleteStartIndex = schichtenIndex;
			}
		}
	} else {
		// Wenn ohne STRG/CTRL geklickt wurde, wird die lösch Selektion aufgehoben
		unmarkiereSchichtenLoeschen();
		const datePicker = document.body.querySelector('#zeiten-datum-input');
		datePicker.value = thisElement.getAttribute('aria-label');
		// entferne die alte visuelle Selection, falls es eine gibt
		removeTagSelection();
		removeSchichtSelection();
		// Selektiere das Schicht Element oder den Tag
		if (thisElement.classList.contains('zeiten-grid')) {
			await selectSchicht(thisElement);
		} else {
			thisElement.classList.add('tag-selected');
			leseRegelarbeitszeiten(datePicker.value);
			document.querySelector('[aria-label="zeiten-Von"]').focus();
		}
	}
}

/**
 * Füllt die von und bis Zeit aus mit den Regelarbeitszeiten/Sollstunden
 * @param {string} datum tagesdatum
 * @param {Boolean} surpressEgfzChange verhindert das automatische Wechsel der EGFZ Art (für Arbeit am FT)
 */
function leseRegelarbeitszeiten(datum = document.getElementById('zeiten-datum-input').value, surpressEgfzChange = false) {
	// Nehme die Uhrzeiten aus der Regelarbeitszeit, falls vorhanden.
	const regelarbeitszeitenMA = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Regelarbeitszeiten;
	const tagIndex = dayjs(datum).day() - 1;
	const egfzSelect = document.querySelector('[aria-label="zeiten-Egfz"]');
	const egfzAuswahl = egfzSelect.value;
	// GZ Aufbau und Arbeit am Feiertag wird wie Arbeitszeit behandelt.
	const egfzArbeit = egfzAuswahl == Egfz.Arbeit || egfzAuswahl == Egfz.GZAufbau || egfzAuswahl == Egfz.ArbeitAmFeiertag;
	const vonHtml = document.querySelector('[aria-label="zeiten-Von"]');
	const bisHtml = document.querySelector('[aria-label="zeiten-Bis"]');
	// Wenn wir Arbeitsschichten wählen, dann fügen wir die Regelarbeitszeiten ein (falls keine Schicht selektiert wurde)
	if (!schichtSelected && egfzArbeit && regelarbeitszeitenMA[tagIndex < 0 ? 6 : tagIndex].Von !== null && regelarbeitszeitenMA[tagIndex < 0 ? 6 : tagIndex].Bis !== null) {
		vonHtml.value = regelarbeitszeitenMA[tagIndex < 0 ? 6 : tagIndex].Von;
		bisHtml.value = regelarbeitszeitenMA[tagIndex < 0 ? 6 : tagIndex].Bis;
	}
	// Wenn wir eine egfz Schicht haben, die nicht Arbeit/GZ+/GZ- ist, dann fügen wir die Sollstunden oder IstStundenProTag ein.
	if (!egfzArbeit && egfzAuswahl != Egfz.GZAbbau) {
		// Bei unbezahlt frei keine genauen Zeitangaben vorschlagen, sondern 0,00h
		if (egfzAuswahl == Egfz.UnbezahltFrei) {
			vonHtml.value = '00:00';
			bisHtml.value = '00:00';
		} else {
			vonHtml.value = regelarbeitszeitenMA[tagIndex < 0 ? 6 : tagIndex].Von ? regelarbeitszeitenMA[tagIndex < 0 ? 6 : tagIndex].Von : '08:00';
			const stdAnzahl = stammdatenService.getMitarbeiterSollstundenEGFZ();
			// Wir addieren die Sollstunden auf 08:00 Uhr
			bisHtml.value = dayjs(`${datum} ${vonHtml.value}`, 'YYYY-MM-DD HH:mm').add(stdAnzahl, 'hours').format('HH:mm');
		}
		// wir müssen auch die Pausen entfernen, falls vorhanden
		const pausenInputHtml = document.body.querySelectorAll('[aria-label="zeiten-Pausen"]');
		pausenInputHtml.forEach((pauseHtml) => pauseHtml.remove());
	}
	// Falls wir GZ- haben, wollen wir keine Pausen, bisherige Zeitangaben bleiben bestehen
	if (egfzAuswahl == Egfz.GZAbbau) {
		// wir müssen auch die Pausen entfernen, falls vorhanden
		const pausenInputHtml = document.body.querySelectorAll('[aria-label="zeiten-Pausen"]');
		pausenInputHtml.forEach((pauseHtml) => pauseHtml.remove());
	}


	// Wir wollen nicht immer die EGFZ Art wechseln
	if (!surpressEgfzChange) {
		// Falls wir auf einen FT wechseln, müssen wir Arbeit am FT auswählen (außer es wurde schon Arbeit am FT gewählt)
		if (egfzAuswahl == Egfz.Arbeit
			&& !schichtSelected
			&& stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0]?.ArbeitAmFeiertag
			&& document.body.querySelector(`.zeiten-list-item[aria-label="${datum}"]`).classList.contains('zeiten-feiertag')) {
			egfzSelect.value = Egfz.ArbeitAmFeiertag;
		}
		
		// Falls wir von einen FT auf normalen Arbeitstag wechseln, müssen wir Arbeit auswählen
		if (egfzAuswahl == Egfz.ArbeitAmFeiertag
			&& !document.body.querySelector(`.zeiten-list-item[aria-label="${datum}"]`).classList.contains('zeiten-feiertag')) {
			egfzSelect.value = Egfz.Arbeit;
		}
	}
	// KostRelevant Eingabe nur für Arbeitsschichten anzeigen (nicht für EGFZ/Urlaub/Krank etc.)
	const kostInput = document.getElementById('zeiten-input-kost');
	if (kostInput) {
		kostInput.style.display = egfzArbeit ? '' : 'none';
	}
	// Update bezahlte Zeit Info
	berechneBezahlteZeit();
}

/**
 * Nach Wählen eines Datums, soll der Tag markiert werden in der Liste
 * @param {HTMLElement} thisElement
 */
async function pickDate(thisElement) {
	try {
		removeTagSelection();
		removeSchichtSelection();
		const datum = thisElement.value;
		const listItem = document.body.querySelector(`[aria-label='${datum}'].zeiten-list-item`);
		listItem.classList.add('tag-selected');
	} catch (error) {
		console.log(error);
		const dialogText = `Geben Sie Bitte ein Datum des aktuell gewählten Monats ein!${thisElement.value}`;
		systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
	}
}

/**
 * Eingabe von Schichtdaten einer bestehenden oder neuen Schicht
 * @param {bool} extra true => neue Schicht am gleichen Tag, false => Schicht editieren falls ausgewählt
 * @returns
 */
async function inputZeiten(extra) {
	// Bei neuer Schicht => alte Schichtauswahl wird aufgehoben
	if (extra) {
		schichtSelected = null;
	}
	// Wir holen uns die Inputdaten aus dem HTML Input Feldern...
	const inputObject = sammleZeitenInput();
	const maEintritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Eintrittsdatum;
	const maAustritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Austrittsdatum;
	// Ohne Eintrittsdatum wird kein Schichteninput erlaubt...
	if (_.isEmpty(maEintritt)) {
		systemNachrichtService.zeigeKleineNachricht('Bitte erst das Eintrittsdatum der Beschäftigung festlegen!', 0);
		return;
	}
	// Falls der user eine Schicht vor dem Eintrittsdatum des Mitarbeiters eingeben will, wird dies geblockt.
	if (inputObject.Datum < maEintritt) {
		systemNachrichtService.zeigeKleineNachricht('Schichtdatum darf nicht vor dem Eintrittsdatum liegen!', -1);
		return;
	}
	// Falls der user eine Schicht nach dem Austrittsdatum des Mitarbeiters eingeben will, wird dies geblockt.
	if (maAustritt && inputObject.Datum > maAustritt) {
		systemNachrichtService.zeigeKleineNachricht('Schichtdatum darf nicht nach dem Austrittsdatum liegen!', -1);
		return;
	}

	if (inputObject === null) {
		return;
	}
	// Speichere input Daten in die Datenbank bevor sie angezeigt werden
	inputObject.MitarbeiterID = stammdatenService.aktuellerMitarbeiter._id;
	inputObject._id = schichtSelected === null ? undefined : schichtSelected;
	// Wir geben mit ob das Pausenmodell verwendet werden soll
	const pausenmodellVerwenden = document.getElementById('zeiten-pausenmodell-aktiv').checked;
	const result = await schichtService.speichereSchicht(inputObject, pausenmodellVerwenden);
	if (!result) {
		return;
	}
	const schichtIndex = zeitenMonat.get().findIndex((zeit) => zeit._id === result._id);
	if (schichtIndex >= 0) {
		zeitenMonat.replace(schichtIndex, result);
	} else {
		zeitenMonat.push(result);
	}
	if (schichtSelected === null) {
		// Neuen Balken erstellen
		await erstelleSchichtElement(result);
	} else {
		// Alten balken editieren
		await editiereSchicht(result);
	}
	if (result.Egfz == 2) {
		const gridItem = document.getElementById(result._id);
		// Falls es noch kein Flieger Symbol gibt, tragen wir es nach
		if (!gridItem.parentNode.querySelector('.tag-urlaub')) {
			const urlaubIcon = document.createElement('i');
			urlaubIcon.className = 'bi bi-airplane-fill tag-urlaub';
			urlaubIcon.title = 'Mitarbeiter ist im Urlaub!';
			gridItem.insertAdjacentElement('beforebegin', urlaubIcon);
		}
	}
	toggleUeberlaengeSymbol(inputObject.MitarbeiterID);
	document.querySelector('[aria-label="zeiten-Von"]').focus();
	unmarkiereSchichtenLoeschen();
}

/**
 * Kontrolliert ob es in den Zeiten Schichten mit markierter Überlänge gibt.
 * - bei ja: Alarmuhr erscheint in Mitarbeiter Liste
 * - bei nein: Alarmuhr ausblenden in der Mitarbeiter Liste
 * @param {string} mitarbeiterID 
 */
function toggleUeberlaengeSymbol(mitarbeiterID) {
	if (document.getElementById('zeiten-liste').querySelectorAll('.ueberlaenge').length > 0) {
		document.getElementById(mitarbeiterID).querySelector('.ma-ueberlaenge-icon').classList.remove('hidden');
	} else {
		document.getElementById(mitarbeiterID).querySelector('.ma-ueberlaenge-icon').classList.add('hidden');
	}
}

// Sammelt die eingebenen Daten aus der Oberfläche und erstellt ein InputObjekt
function sammleZeitenInput() {
	try {
		// Merke den Input Cointainer, um die verschiedenen Inputfelder auszulesen
		const zeitenInputBody = document.body.querySelector('#zeiten-input-body');
		// Neues Inputobjekt
		const inputObject = {};
		inputObject.Datum = zeitenInputBody.querySelector('#zeiten-datum-input').value;
		if (inputObject.Datum === '') {
			const dialogText = 'Bitte ein Datum auswählen!';
			systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
			return null;
		}
		// HH:mm values auslesen
		const vonStr = zeitenInputBody.querySelector('[aria-label="zeiten-Von"]').value;
		const bisStr = zeitenInputBody.querySelector('[aria-label="zeiten-Bis"]').value;
		if (vonStr === '' || bisStr === '') {
			const dialogText = 'Bitte von und bis Zeiten angeben!';
			systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
			return null;
		}
		inputObject.Von = vonStr;
		inputObject.Bis = bisStr;
		inputObject.Egfz = parseInt(zeitenInputBody.querySelector('[aria-label="zeiten-Egfz"]').value, 10);
		inputObject.Titel = basedataService.egfz.find((e) => e.EGFZID === inputObject.Egfz)?.BezeichnungDienstplan;
		inputObject.Notiz = zeitenInputBody.querySelector('[aria-label="zeiten-Notiz"]').value;

		const qualiSelect = zeitenInputBody.querySelector('[aria-label="zeiten-QualifikationID"]');
		const einsatzortSelect = zeitenInputBody.querySelector('[aria-label="zeiten-EinsatzortID"]');
		const postenSelect = zeitenInputBody.querySelector('[aria-label="zeiten-PostenID"]');
		if (qualiSelect.options.length <= 0) {
			const dialogText = 'Mitarbeiter besitzt keine Qualifikation!';
			systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
			return null;
		}
		if (postenSelect.options.length <= 0) {
			const dialogText = 'Mitarbeiter ist keinem Posten zugeordnet!';
			systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
			return null;
		}
		inputObject.Qualifikation = qualiSelect.options[qualiSelect.selectedIndex].innerText;
		inputObject.Posten = postenSelect.options[postenSelect.selectedIndex].innerText;
		inputObject.Einsatzort = einsatzortSelect.options[einsatzortSelect.selectedIndex].innerText;
		inputObject.QualifikationID = qualiSelect.value;
		inputObject.PostenID = postenSelect.value;
		inputObject.EinsatzortID = einsatzortSelect.value;
		inputObject.BetriebsstaetteID = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].BetriebsstaetteID;
		// UrlaubID mitaufnehmen, falls vorhanden...
		if (schichtSelected !== null) {
			const schichtAlt = document.getElementById(schichtSelected);
			const urlaubID = schichtAlt.querySelector('[aria-label="UrlaubID"]').innerText;
			if (urlaubID !== '') {
				inputObject.UrlaubID = urlaubID;
			}
		}

		// Pausen aus der Oberfläche entnehmen
		const pausenElemente = zeitenInputBody.querySelectorAll('[aria-label="zeiten-Pausen"]');
		inputObject.Pausen = lesePausen(pausenElemente, inputObject.Datum, inputObject.Von);
		validierePausen(inputObject);
		const pausenZeiten = berechnePausenZeit();
		inputObject.Pausenzeit = pausenZeiten.PauseGesamt;
		inputObject.Gesamtzeit = dayjs.getDurationHHmm(inputObject.Von, inputObject.Bis);
		inputObject.Bezahltezeit = inputObject.Gesamtzeit - pausenZeiten.PauseUnbezahlt;
		// Für das Zeitbalken format in HH:mm ausgeben
		inputObject.Pausenzeit = dayjs.duration(inputObject.Pausenzeit, 'minutes').format('HH:mm');
		inputObject.Gesamtzeit = dayjs.duration(inputObject.Gesamtzeit, 'minutes').format('HH:mm');
		inputObject.Bezahltezeit = dayjs.duration(inputObject.Bezahltezeit, 'minutes').format('HH:mm');
		inputObject.Umsatz = parseFloat(zeitenInputBody.querySelector('[aria-label="zeiten-Umsatz"]').value);
		inputObject.KostRelevant = zeitenInputBody.querySelector('[aria-label="zeiten-KostRelevant"]').checked;
		return inputObject;
	} catch (error) {
		systemNachrichtService.zeigeKleineNachricht('Unvollständige Inputdaten vorhanden!', -1);
		console.log(error);
		throw new Error('Invalider User Input');
	}
}

// checkt ob die Pausen im schichtObjekt valide sind zum Speichern
function validierePausen(schichtObjekt) {
	let isValid = true;
	schichtObjekt.Pausen = schichtObjekt.Pausen.filter((pause) => {
		// Pausen müssen innerhalb der Schicht liegen:
		isValid = isValid && dayjs.isTimeInRangeHHmm(pause.Von, schichtObjekt.Von, schichtObjekt.Bis); // Pause Von muss zwischen Schicht Von / Bis kommen
		isValid = isValid && dayjs.isTimeInRangeHHmm(pause.Bis, pause.Von, schichtObjekt.Bis); // Pause Bis muss nach Pause Von kommen
		isValid = isValid && pause.Von !== pause.Bis; // keine leeren Pausen
		return isValid;
	});
}

// Rendert ein neues Schichten Element für die Oberfläche aus dem Zeitenobjekt vom Server
async function erstelleSchichtElement(schichtObjekt, initialLoad = false) {
	// Datum immer in Deutscher Zeitzone anzeigen
	schichtObjekt.Datum = dayjs(schichtObjekt.Datum).tz();

	const abrechnungstag = stammdatenService.unternehmensobjekt.Abrechnungstag;
	let startOfMonth = window.myVars.aktuellesMonatsDatum.startOf('month');
	let endOfMonth = window.myVars.aktuellesMonatsDatum.endOf('month');
	// Wenn das Unternehmen ein Abrechnungstag früher hat, dann müssen wir die Zeiten anders anzeigen.
	// Zum Beispiel: Abrechnungstag ist er 15., dann sollte man alle Zeiten vom 16. des Vormonats bis zum 15. des aktuellen Monats anzeigen.
	if (abrechnungstag < 31) {
		startOfMonth = startOfMonth.subtract(1, 'month').add(abrechnungstag, 'days');
		endOfMonth = endOfMonth.startOf('month').add(abrechnungstag - 1, 'days');
	}
	// Render nur Elemente, die dem aktuellen Monat zuegordnet sind! Early return falls nicht.
	if (!schichtObjekt.Datum.isBetween(startOfMonth, endOfMonth, 'month', '[]')) {
		return;
	}
	// Laden des Templates für den Balken
	const template = document.body.querySelector('[zeiten-grid-template]');
	// Tag Element in der Liste finden
	const queryStr = `[aria-label='${schichtObjekt.Datum.format('YYYY-MM-DD')}'].zeiten-list-item`;
	const listItem = document.body.querySelector(queryStr);
	// Schichtblock erstellen
	const neuerBalken = template.content.cloneNode(true).children[0];
	neuerBalken.id = schichtObjekt._id;
	neuerBalken.setAttribute('aria-label', schichtObjekt.Datum.format('YYYY-MM-DD'));
	// Schichblock dem Tag hinzufügen
	listItem.appendChild(neuerBalken);
	await fuelleSchichtBalken(schichtObjekt);
	showRows(zeitenAnsicht);
	if (!initialLoad) {
		// springe zum nächsten Tag...
		await springeZeile();
	}
}

// Navigationshilfe für die Navigation durch Pfeiltasten innerhalb der Zeitenliste
async function springeZeile(richtung = 1) {
	const monatstageListe = [...document.querySelectorAll('.zeiten-list-item')];
	const currentIndex = monatstageListe.findIndex((tag) => tag.classList.contains('tag-selected'));
	removeTagSelection();
	removeSchichtSelection();
	let folgeTag;
	// Durchwählen der Tage
	if (currentIndex < 0) {
		folgeTag = monatstageListe[0];
	} else if (currentIndex === 0 && richtung === -1) {
		folgeTag = monatstageListe[monatstageListe.length - 1];
	} else if (currentIndex === monatstageListe.length - 1 && richtung === 1) {
		folgeTag = monatstageListe[0];
	} else {
		folgeTag = monatstageListe[currentIndex + richtung];
	}
	const datumAktuell = folgeTag.getAttribute('aria-label');
	document.body.querySelector('#zeiten-datum-input').value = folgeTag.getAttribute('aria-label');
	folgeTag.classList.add('tag-selected');
	leseRegelarbeitszeiten(datumAktuell);
	const naechsteSchicht = folgeTag.querySelector('.zeiten-grid');
	if (naechsteSchicht !== null) {
		await selectSchicht(naechsteSchicht);
	} else {
		setTimeout(() => folgeTag.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }), 100);
	}
	document.querySelector('[aria-label="zeiten-Von"]').focus();
}

// Hebt die Auswahl eines bestimmten Tages auf
function removeTagSelection() {
	const prevSelections = document.body.querySelectorAll('.tag-selected');
	if (prevSelections.length >= 1) {
		prevSelections.forEach((tag) => { tag.classList.remove('tag-selected'); });
	}
}

// Hebt die Auswahl einer bestimmten Schicht auf
function removeSchichtSelection() {
	// bei Aufhebung der Auswahl resetten wir auch das Umsatzfeld
	document.body.querySelector('[aria-label="zeiten-Umsatz"]').value = 0;
	// KostRelevant standardmäßig aktiv für neue Schichten
	document.body.querySelector('[aria-label="zeiten-KostRelevant"]').checked = true;
	const prevSelections = document.body.querySelectorAll('.zeiten-item-selected');
	if (prevSelections.length >= 1) {
		prevSelections.forEach((schicht) => { schicht.classList.remove('zeiten-item-selected'); });
	}
	schichtSelected = null;
}

// Zeigt Änderungen einer Schicht in der Oberfläche an
async function editiereSchicht(schichtObjekt) {
	await fuelleSchichtBalken(schichtObjekt);
	await springeZeile();
}

// Füllt einen bestehenden Balken mit neuen Input
async function fuelleSchichtBalken(schichtObjekt) {
	const balken = document.body.querySelector(`[id="${schichtObjekt._id}"]`);
	const balkenArray = Array.from(balken.children);
	const egfz = await basedataService.holeEgfzBasedataProvider();
	// Aktuell beim Mitarbeiter hinterlegte Qualifikationen/Posten/Einsatzorte, um verwaiste IDs in der Schicht zu erkennen
	const qualisMA = holeQualifikationenMitarbeiter();
	const postenMA = holePostenMitarbeiter();
	const einsatzorteMA = holeEinsatzorteMitarbeiter();
	const ungueltigeFelder = [];
	balkenArray.forEach((feld) => {
		const label = feld.getAttribute('aria-label');
		// Wird nach der Schleife separat befüllt, hier keine automatische Textbefüllung vornehmen
		if (label === 'ReferenzWarnung') {
			return;
		}
		if (label === 'Von' || label === 'Bis') {
			let zeitText = dayjs(schichtObjekt[label]).tz().format('HH:mm');
			if (label === 'Bis' && !dayjs(schichtObjekt[label]).isValid()) {
				zeitText = 'offen';
			}
			feld.dataset.geplant = zeitText;
			let badges = '';
			// GPS badge
			const hasGps = (label === 'Von' && schichtObjekt?.GeolocationStart) ||
				(label === 'Bis' && schichtObjekt?.GeolocationEnde);
			if (hasGps) {
				const gpsTitle = label === 'Von' ? 'Standort beim Einstempeln' : 'Standort beim Austempeln';
				const gpsIcon = label === 'Von' ? 'bi-geo-alt-fill' : 'bi-geo-alt';
				badges += `<span class="gps-badge" title="${gpsTitle}"><i class="bi ${gpsIcon}"></i></span>`;
			}
			// Stempel badge
			if (schichtObjekt?.StempelZeiten?.length > 0) {
				const aktionLabel = label === 'Von' ? 'Schicht Start' : 'Schicht Ende';
				const stempel = schichtObjekt.StempelZeiten.find((s) => s.Aktion === aktionLabel);
				if (stempel) {
					const stempelDayjs = dayjs(stempel.Zeit).tz();
					const dayDiff = stempelDayjs.diff(dayjs(schichtObjekt.Datum).tz(), 'day');
					const stempelZeit = dayDiff > 0
						? `+${dayDiff}d ${stempelDayjs.format('HH:mm')}`
						: stempelDayjs.format('HH:mm');
					const stempelLabel = label === 'Von' ? 'Start' : 'Ende';
					const stempelTooltip = `${stempelLabel}: ${stempelDayjs.format('DD.MM.YYYY, HH:mm')} Uhr`;
					const aktionIcon = label === 'Von' ? 'bi-box-arrow-in-right' : 'bi-box-arrow-right';
					badges += `<span class="stempel-zeit" title="${stempelTooltip}"><i class="bi ${aktionIcon}"></i>${stempelZeit}</span>`;
				}
			}
			feld.innerHTML = badges
				? `<span class="stempel-wrap">${badges}${zeitText}</span>`
				: zeitText;
			// Attach map events to GPS badge after innerHTML is set
			if (hasGps) {
				standortMap.addMapEvents(feld.querySelector('.gps-badge'), schichtObjekt.GeolocationStart, schichtObjekt.GeolocationEnde);
			}
		} else if (label === 'Egfz') {
			const egfzBDP = egfz.find((e) => e.EGFZID === schichtObjekt[label]);
			feld.innerText = egfzBDP?.BezeichnungKurz ? egfzBDP?.BezeichnungKurz : '?';
			feld.title = egfzBDP?.Bezeichnung;
		} else if (label === 'Bezahltezeit') {
			// Wir haben überlänge falls die bezahlte Schichtzeit > 1 Tag oder > 10 Stunden ist.
			if (schichtObjekt[label].split(':').length > 2 || Number(schichtObjekt[label].split(':')[0]) > 10) {
				feld.classList.add('ueberlaenge');
				feld.title = 'bezahlte Zeit länger als 10 Stunden!';
				feld.innerHTML = schichtObjekt[label] + '<i class="bi bi-alarm-fill" title="bezahlte Zeit länger als 10 Stunden!"></i>';
			} else if (schichtObjekt['Egfz'] === Egfz.GZAufbau) {
				// Falls wir überlange GZ+ Schichten haben, dann ist der Mitarbeiter wahrscheinlich nicht ausgestempelt
				if (schichtObjekt.GesamtStunden - schichtObjekt.PauseUnbezahltStunden > 10) {
					feld.classList.add('ueberlaenge');
					feld.title = 'Ausstempeln vergessen? Gutzeit Aufbau Zeit länger als 10 Stunden!';
					feld.innerHTML = schichtObjekt['Gesamtzeit'] + '<i class="bi bi-alarm-fill" title="Ausstempeln vergessen? Gutzeit Aufbau Zeit länger als 10 Stunden!"></i>';
				} else {
					feld.innerHTML = schichtObjekt['Gesamtzeit'];
					feld.classList.remove('ueberlaenge');
				}
			} else {
				feld.classList.remove('ueberlaenge');
				feld.innerHTML = schichtObjekt[label];
			}
		} else if (label === 'Notiz') {
			if (schichtObjekt[label]) {
				balken.title = `Notiz: ${schichtObjekt[label]}`;
				feld.title = `Notiz: ${schichtObjekt[label]}`;
				feld.style.display = 'block';
			} else {
				balken.title = '';
				feld.title = '';
				feld.style.display = 'none';
			}
		} else if (label === 'Posten' || label === 'Qualifikation' || label === 'Einsatzort') {
			const value = schichtObjekt[label] ?? '';
			const truncatedValue = value.length > 16 ? `${value.substring(0, 15)}…` : value;
			const idKey = { Posten: 'PostenID', Qualifikation: 'QualifikationID', Einsatzort: 'EinsatzortID' }[label];
			const gueltigeListe = { Posten: postenMA, Qualifikation: qualisMA, Einsatzort: einsatzorteMA }[label];
			// ID am Mitarbeiter nicht (mehr) hinterlegt (z.B. nachträglich entfernt)?
			const referenzUngueltig = !!schichtObjekt[idKey] && !gueltigeListe.some((eintrag) => eintrag[idKey] === schichtObjekt[idKey]);
			feld.classList.toggle('referenz-ungueltig', referenzUngueltig);
			if (referenzUngueltig) {
				ungueltigeFelder.push(label);
				const hinweis = `${label} "${value}" ist beim Mitarbeiter nicht (mehr) hinterlegt! Bitte die Schicht bearbeiten, ${label} neu auswählen und speichern.`;
				feld.title = hinweis;
				feld.innerHTML = `<span class="referenz-warn-wrap"><i class="bi bi-exclamation-triangle-fill referenz-warn-icon" title="${hinweis}"></i>${truncatedValue}</span>`;
			} else {
				feld.title = value;
				feld.innerText = truncatedValue;
			}
		} else if (label === 'Bestaetigt') {
			// wird nach der Schleife separat behandelt (Grey-out + Hover-Bestätigen)
		} else {
			const value = schichtObjekt[label] ?? '';
			feld.innerText = value;
			feld.title = value;
		}
	});
	// GZ+- Markierungen
	schichtObjekt.Egfz === Egfz.GZAbbau ? balken.classList.add('egfz-gzminus') : balken.classList.remove('egfz-gzminus');
	const feiertagGutzeit = schichtObjekt.Egfz === Egfz.ArbeitAmFeiertag && stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0]?.ArbeitAmFeiertag === ArbeitAmFeiertagTyp.Gutzeit;
	schichtObjekt.Egfz === Egfz.GZAufbau || feiertagGutzeit ? balken.classList.add('egfz-gzplus') : balken.classList.remove('egfz-gzplus');
	// Balken-weite Markierung, falls eine ungültige Qualifikations-, Posten- oder Einsatzort-Referenz vorliegt
	balken.classList.toggle('zeiten-referenz-ungueltig', ungueltigeFelder.length > 0);
	// Immer sichtbares Warn-Icon, damit man das Problem auch bei ausgeblendeter zweiter Zeile sofort sieht
	const referenzWarnFeld = balken.querySelector('[aria-label="ReferenzWarnung"]');
	if (ungueltigeFelder.length > 0) {
		referenzWarnFeld.title = `Ungültige Referenz: ${ungueltigeFelder.join(', ')}. Bitte die Schicht bearbeiten, die markierten Felder neu auswählen und speichern.`;
		referenzWarnFeld.style.display = 'block';
	} else {
		referenzWarnFeld.title = '';
		referenzWarnFeld.style.display = 'none';
	}

	// Unbestätigte Schichten ausgrauen, per Hover über den gesamten Balken ein Popup mit Kamerabildern
	// + Bestätigen-Button anzeigen (das kleine Eck-Icon dient nur noch als visueller Hinweis).
	const istUnbestaetigt = bestaetigungNotwendig && schichtObjekt.Bestaetigt === false;
	balken.classList.toggle('zeiten-unbestaetigt', istUnbestaetigt);
	// Aktuelle Referenz merken, damit der (nur einmalig gebundene) Hover-Handler immer mit den
	// aktuellen Daten arbeitet, auch wenn fuelleSchichtBalken() später erneut aufgerufen wird.
	balken.zeitenBestaetigungObjekt = schichtObjekt;
	if (!balken.dataset.bestaetigenHoverGebunden) {
		balken.dataset.bestaetigenHoverGebunden = 'true';
		kameraPopup.addHoverEvents(
			balken,
			() => {
				const aktuellesSchichtObjekt = balken.zeitenBestaetigungObjekt;
				return Promise.all((aktuellesSchichtObjekt.KameraBilder || []).map((bild) => schichtService.leseKamerabild(bild._id)));
			},
			(popup, geladeneBilder) => renderBestaetigungsPopup(popup, geladeneBilder, balken.zeitenBestaetigungObjekt),
			250,
			// Popup nur anzeigen, falls der Balken zum Zeitpunkt des Hovers (noch) unbestätigt ist.
			() => balken.classList.contains('zeiten-unbestaetigt')
		);
	}
}

/**
 * Rendert den Inhalt des Hover-Popups für eine unbestätigte Schicht: Kamerabilder (falls vorhanden)
 * plus einen Bestätigen-Button.
 * @param {HTMLElement} popup
 * @param {Array<object|null>} geladeneBilder
 * @param {object} schichtObjekt aktuelle Schicht (Zeiten-Objekt)
 */
function renderBestaetigungsPopup(popup, geladeneBilder, schichtObjekt) {
	if (geladeneBilder.some((bild) => bild)) {
		renderKamerabilderInPopup(popup, geladeneBilder);
	} else {
		const info = document.createElement('div');
		info.className = 'kamera-popup-bild';
		info.innerText = 'Keine Kamerabilder vorhanden';
		popup.appendChild(info);
	}
	const bestaetigenBtn = document.createElement('button');
	bestaetigenBtn.type = 'button';
	bestaetigenBtn.className = 'kamera-popup-bestaetigen-btn';
	bestaetigenBtn.innerText = 'Schicht bestätigen';
	bestaetigenBtn.addEventListener('click', async () => {
		const result = await schichtService.bestaetigeSchicht(schichtObjekt._id);
		if (!result) return;
		schichtObjekt.Bestaetigt = true;
		schichtObjekt.BestaetigtVon = result.BestaetigtVon;
		schichtObjekt.BestaetigtAm = result.BestaetigtAm;
		kameraPopup.hide();
		await fuelleSchichtBalken(schichtObjekt);
		// Summenzeile neu berechnen, da unbestätigte Schichten bei aktiver Bestätigungspflicht nicht mitgezählt werden.
		const schichtIndex = zeitenMonat.get().findIndex((zeit) => zeit._id === schichtObjekt._id);
		if (schichtIndex >= 0) {
			zeitenMonat.replace(schichtIndex, schichtObjekt);
		}
	});
	popup.appendChild(bestaetigenBtn);
}

// Auswahl einer bestimmten Schicht und laden dessen aktueller Daten
async function selectSchicht(thisElement) {
	removeSchichtSelection();
	schichtSelected = thisElement.id;
	const result = await clickLeseSchicht(schichtSelected);
	if (_.isEmpty(result)) {
		return;
	}
	thisElement.parentElement.classList.add('tag-selected');
	thisElement.classList.add('zeiten-item-selected');
	const childrenArray = Array.from(thisElement.children);
	const egfz = await basedataService.holeEgfzBasedataProvider();
	// Fülle das Input Control mit den Schichtwerten
	childrenArray.forEach((element) => {
		const label = element.getAttribute('aria-label');
		if (!['Pausenzeit', 'Einsatzort', 'Posten', 'Qualifikation', 'Egfz', 'UrlaubID', 'Umsatz', 'JournalID', 'BezahlteStunden', 'GesamtStunden', 'PauseUnbezahltStunden', 'Notiz', 'Bestaetigt', 'ReferenzWarnung'].includes(label)) {
			document.body.querySelector(`[aria-label="zeiten-${label}"]`).value = element.dataset.geplant ?? element.innerText;
		}
		if (label === 'Egfz') {
			const egfzID = egfz.find((e) => e.BezeichnungKurz === element.innerText)?.EGFZID;
			document.body.querySelector(`[aria-label="zeiten-${label}"]`).value = egfzID ? egfzID : '';
		}
		if (label === 'Umsatz') {
			document.body.querySelector(`[aria-label="zeiten-${label}"]`).value = parseFloat(element.innerText).toFixed(2);
		}
		if (label === 'Notiz') {
			document.body.querySelector(`[aria-label="zeiten-${label}"]`).value = element.title.substring(7);
		}
	});
	// KostRelevant aus der geladenen Schicht übernehmen (default true bei Altschichten) und Sichtbarkeit anhand Egfz steuern
	document.querySelector('[aria-label="zeiten-KostRelevant"]').checked = result.KostRelevant !== false;
	const kostInput = document.getElementById('zeiten-input-kost');
	if (kostInput) {
		const istArbeitEgfz = [Egfz.Arbeit, Egfz.GZAufbau, Egfz.ArbeitAmFeiertag].includes(result.Egfz);
		kostInput.style.display = istArbeitEgfz ? '' : 'none';
	}
	document.querySelector('[aria-label="zeiten-Von"]').focus();
	thisElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
	unmarkiereSchichtenLoeschen();

	document.querySelectorAll('[aria-label="zeiten-Pausen"]').forEach((element) => element.remove());
	const pausenListe = document.getElementById('pausen-liste');
	result.Pausen.forEach((pause) => {
		pause.Von = dayjs(pause.Von).tz().format('HH:mm');
		pause.Bis = dayjs(pause.Bis).tz().format('HH:mm');
		pausenListe.insertAdjacentHTML('beforeend', getNeuePauseHTML(pause));
	});
}

// Fügt eine neue Zeile bei der Pauseneingabe ein
function neuePause() {
	document.getElementById('pausen-liste').insertAdjacentHTML('beforeend', getNeuePauseHTML());
}

// HTML Code für eine Pausenzeile
function getNeuePauseHTML(pause = { Von: '', Bis: '', Bezahlt: false }) {
	return `<div aria-label="zeiten-Pausen" class="pause-input">
			<span class="pause-field">
				<input type="time" aria-label="pause-Von" class="zeiten-input zeiten-pause-input" onchange="myHandlers.berechneBezahlteZeit()" value="${pause.Von}"/>
				<span class="pause-dash">–</span>
				<input type="time" aria-label="pause-Bis" class="zeiten-input zeiten-pause-input" onchange="myHandlers.berechneBezahlteZeit()" value="${pause.Bis}"/>
			</span>
			<span class="pause-flag" title="bezahlte Pause?">
				<input type="checkbox" aria-label="pause-Bezahlt" onchange="myHandlers.berechneBezahlteZeit()" ${!pause.Bezahlt ? '' : 'checked'} />
				<label>€</label>
			</span>
			<span class="pause-flag" title="Raucherpause?">
				<input type="checkbox" aria-label="pause-Raucherpause" ${!pause.Raucherpause ? '' : 'checked'} />
				<label>RP</label>
			</span>
			<span class="pause-delete" onclick="this.closest('.pause-input').remove()" title="Pause entfernen"><i class="bi bi-trash-fill"></i></span>
		</div>`;
}


// Navigationsevents
async function inputNavigation(event) {
	const isEditable = window.myVars.zeitenEditable;
	// verhindere, dass Pfeiltasten was anderes machen als die Tag/Schicht Auswahl
	if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
		// Im Umsatzfeld wollen wir noch das default Verhalten behalten für den Input.
		if (event.target.tagName === 'INPUT' && (event.target.type === 'number' || event.target.classList.contains('zeiten-pause-input'))) {
			return;
		}
		event.preventDefault();
	}
	// Makiere mehrere Schichten zum Löschen
	if (isEditable && event.shiftKey && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
		markiereSchichtenLoeschen(event);
		return;
	}
	if (isEditable && isMultiSelectModifier(event) && event.key.toUpperCase() === 'A') {
		event.preventDefault();
		markiereAlleSchichtenLoeschen();
		return;
	}
	// verhindere, dass zwei Schichten eingefügt werden, wenn man mit Enter auf OK drückt
	if (event.key === 'Enter' && event.target.type === 'button') {
		return;
	}
	if (isEditable && event.key === 'Enter') {
		enterElement(event);
		return;
	}
	if (isEditable && (event.key === 'Delete' || event.key === 'Backspace')) {
		// Im Umsatzfeld und Notizfeld brauchen wir diese Tasten ohne die Schicht zu löschen.
		if ((event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') && (event.target.type === 'number' || event.target.type === 'text' || event.target.type === 'textarea')) {
			return;
		}
		await deleteElements(event);
		return;
	}
	if (event.key === 'ArrowDown' || event.key === '+') {
		await wechsleTag(1);
		return;
	}
	if (event.key === 'ArrowUp' || event.key === '-') {
		await wechsleTag(-1);
		return;
	}
	if (event.key === 'ArrowLeft') {
		await wechsleSchichtHorizontal(-1);
		return;
	}
	if (event.key === 'ArrowRight') {
		await wechsleSchichtHorizontal(1);
	}
}

// wechselt den Tag und markiert diesen
async function wechsleTag(richtung) {
	await springeZeile(richtung);
}

// Wechselt zwischen Schichten am gleichen Tag
async function wechsleSchichtHorizontal(richtung) {
	const datum = document.querySelector('#zeiten-datum-input').value;
	if (datum === '') return;
	let aktuelleSchicht = document.querySelector('.zeiten-item-selected');
	if (aktuelleSchicht === null) {
		// Wähle Sie aus, falls es eine gibt...
		aktuelleSchicht = document.querySelector(`[aria-label='${datum}'].zeiten-grid`);
		if (aktuelleSchicht === null) return;
	} else {
		// Gehe zur nächsten Schicht...
		let schichten = document.querySelectorAll(`[aria-label='${datum}'].zeiten-grid`);
		schichten = Array.from(schichten);
		schichtenIndex = schichten.indexOf(aktuelleSchicht);
		if (richtung === -1) {
			// links
			schichtenIndex -= 1;
			if (schichtenIndex < 0) {
				removeSchichtSelection();
				return;
			}
		} else {
			// rechts
			schichtenIndex += 1;
			if (schichtenIndex >= schichten.length) {
				removeSchichtSelection();
				return;
			}
		}
		aktuelleSchicht = schichten[schichtenIndex];
	}
	await selectSchicht(aktuelleSchicht);
}

// Initialisiert den Löschvorgang von Schichten und ruft ein Dialog auf
async function deleteElements(event) {
	event.preventDefault();
	// Falls wir nur eine bestimmte Schicht löschen wollen
	if (schichtSelected !== null) {
		const schichtElement = document.getElementById(schichtSelected);
		// Wenn wir eine Urlaubsschicht entfernen wollen, wird die Möglichkeit gegeben den Urlaubsantrag zu löschen
		if (checkDeleteUrlaub(schichtElement)) {
			await deleteUrlaubBySchicht(schichtElement);
			return;
		}
		const input = await SystemDialogService.instance.displayAsync('zeiten-delete-dialog');
		if (!input.success) {
			await springeZeile(0);
			return;
		}
		await entferneSchicht();
		await springeZeile(1);
		return;
	}
	// Falls wir mehrere Schichten löschen wollen
	const schichten = Array.from(document.querySelectorAll('.zeiten-item-loeschen'));
	if (schichten.length >= 1) {
		if (schichten.length === 1 && checkDeleteUrlaub(schichten[0])) {
			await deleteUrlaubBySchicht(schichten[0]);
			return;
		}
		const enthaeltUrlaub = schichten.some((schicht) => checkDeleteUrlaub(schicht));
		if (enthaeltUrlaub) {
			systemNachrichtService.zeigeKleineNachricht('Urlaubsschichten bitte einzeln auswählen und widerrufen.');
			return;
		}
		const input = await SystemDialogService.instance.displayAsync('zeiten-delete-dialog');
		if (!input.success) {
			await springeZeile(0);
			return;
		}
		await entferneSchicht();
		await springeZeile(0);
	}
	toggleUeberlaengeSymbol(stammdatenService.aktuellerMitarbeiter._id);
}

// Ausführen des Löschvorgangs nach OK im Dialog
async function entferneSchicht() {
	if (schichtSelected !== null) {
		const schichtElement = document.getElementById(schichtSelected);
		await schichtService.zeitLoeschen(schichtSelected);
		const schichtIndex = zeitenMonat.get().findIndex((zeit) => zeit._id === schichtSelected);
		zeitenMonat.remove(schichtIndex);
		schichtElement.remove();
	}
	if (document.querySelectorAll('.zeiten-item-loeschen').length >= 1) {
		const zeitenItems = document.querySelectorAll('.zeiten-item-loeschen');
		zeitenItems.forEach(async (schicht) => {
			await schichtService.zeitLoeschen(schicht.id);
			const schichtIndex = zeitenMonat.get().findIndex((zeit) => zeit._id === schicht.id);
			zeitenMonat.remove(schichtIndex);
			schicht.remove();
		});
	}
	schichtSelected = null;
}

/**
 * Überprüft ob die Schicht eine Urlaubsschicht ist, falls ja wird true returned
 * @param {HTMLElement} schichtElement
 * @returns
 */
function checkDeleteUrlaub(schichtElement) {
	const urlaubID = schichtElement.querySelector('[aria-label="UrlaubID"]').innerText;
	const regex = /^[0-9a-fA-F]{24}$/;
	if (urlaubID && regex.test(urlaubID)) {
		return true;
	}
	return false;
}

function getUrlaubBySchicht(schichtElement) {
	if (!schichtElement) {
		return null;
	}
	const urlaubID = schichtElement.querySelector('[aria-label="UrlaubID"]')?.innerText;
	if (!urlaubID) {
		return null;
	}
	return stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Urlaubsantraege.find((ua) => ua._id === urlaubID) || null;
}

function setDeleteUrlaubDialogText(urlaubsantrag) {
	const zeitraumElement = document.getElementById('zeiten-delete-urlaub-zeitraum');
	if (!zeitraumElement) {
		return;
	}
	if (!urlaubsantrag) {
		zeitraumElement.innerText = '';
		return;
	}
	const urlaubVon = dayjs(urlaubsantrag.UrlaubVon).tz().format('DD.MM.YYYY');
	const urlaubBis = dayjs(urlaubsantrag.UrlaubBis).tz().format('DD.MM.YYYY');
	zeitraumElement.innerText = `${urlaubVon} - ${urlaubBis}`;
}

async function deleteUrlaubBySchicht(schichtElement) {
	const urlaubsantrag = getUrlaubBySchicht(schichtElement);
	if (!urlaubsantrag) {
		systemNachrichtService.zeigeKleineNachricht('Urlaubsantrag nicht gefunden!', -1);
		return;
	}
	setDeleteUrlaubDialogText(urlaubsantrag);
	const input = await SystemDialogService.instance.displayAsync('zeiten-delete-urlaub-dialog');
	setDeleteUrlaubDialogText(null);
	if (!input.success) {
		return;
	}
	const result = await schichtService.entferneUrlaub(stammdatenService.aktuellerMitarbeiter._id, urlaubsantrag._id, 'abgelehnt');
	if (!result) {
		return;
	}
	await stammdatenService.holeMitarbeiter(stammdatenService.aktuellerMitarbeiter._id);
	await zeitenScript(true);
}

// Berechnet die eigentliche bezahlte Zeit einer Schicht.
function berechneBezahlteZeit(event) {
	// Falls keine Schicht ausgewählt ist und wir von/bis Zeiten ändern, dann löschen wir die Pausen...
	if (event && !schichtSelected) {
		const pausenInputHtml = document.body.querySelectorAll('[aria-label="zeiten-Pausen"]');
		pausenInputHtml.forEach((pauseHtml) => pauseHtml.remove());
	}
	const zeitenInputBody = document.body.querySelector('#zeiten-input-body');
	const von = zeitenInputBody.querySelector('[aria-label="zeiten-Von"]').value;
	const bis = zeitenInputBody.querySelector('[aria-label="zeiten-Bis"]').value;
	if (von === '' || bis === '') return;
	let bezahlteZeit = dayjs.getDurationHHmm(von, bis);
	const pausenzeiten = berechnePausenZeit();
	bezahlteZeit = bezahlteZeit - pausenzeiten.PauseUnbezahlt;
	zeitenInputBody.querySelector('[aria-label="zeiten-Bezahltezeit"]').value = dayjs
		.duration(bezahlteZeit, 'minutes')
		.format('HH:mm');
}

// Berechnet die ausgewählten Pausenzeiten
function berechnePausenZeit() {
	const pausenInputHtml = document.body.querySelectorAll('[aria-label="zeiten-Pausen"]');
	let PauseUnbezahlt = 0;
	let PauseGesamt = 0;
	pausenInputHtml.forEach((pause) => {
		const von = pause.querySelector('[aria-label="pause-Von"]').value;
		const bis = pause.querySelector('[aria-label="pause-Bis"]').value;
		if (von === '' || bis === '') return;
		const pauseDiff = dayjs.getDurationHHmm(von, bis);
		if (!pause.querySelector('[aria-label="pause-Bezahlt"]').checked) {
			PauseUnbezahlt += pauseDiff;
		}
		PauseGesamt += pauseDiff;
	});

	return { PauseGesamt, PauseUnbezahlt };
}

// Liest die Pausen aus dem Input Feldern
function lesePausen(pausenInputHtml, schichtDate, schichtVon) {
	const pausen = [];
	pausenInputHtml.forEach((pause) => {
		const pauseVon = pause.querySelector('[aria-label="pause-Von"]');
		const pauseBis = pause.querySelector('[aria-label="pause-Bis"]');
		// Falls eine Pause nicht angegeben ist, oder diese den gleichen Wert haben, überspringen wir die Pause.
		if ((pauseVon.value === '' || pauseBis.value === '') || (pauseVon.value === pauseBis.value)) {
			return;
		}
		const p = {};
		p.Von = pauseVon.value;
		p.Bis = pauseBis.value;
		p.Bezahlt = pause.querySelector('[aria-label="pause-Bezahlt"]').checked;
		p.Raucherpause = pause.querySelector('[aria-label="pause-Raucherpause"]').checked;
		p.Gesamt = dayjs.getDurationHHmm(p.Von, p.Bis);
		pausen.push(p);
	});
	// Sort breaks chronologically considering shift start time
    pausen.sort((a, b) => {
        // Create dayjs objects for comparison (use picked date as base)
        const baseDate = schichtDate;
        const aTime = dayjs(`${baseDate} ${a.Von}`, 'YYYY-MM-DD HH:mm');
        const bTime = dayjs(`${baseDate} ${b.Von}`, 'YYYY-MM-DD HH:mm');
        const schichtVonTime = dayjs(`${baseDate} ${schichtVon}`, 'YYYY-MM-DD HH:mm');
        
        // If break is before shift start time, add 1 day (next day break after midnight)
        let aTimeAdjusted = aTime.isBefore(schichtVonTime) ? aTime.add(1, 'day') : aTime;
        let bTimeAdjusted = bTime.isBefore(schichtVonTime) ? bTime.add(1, 'day') : bTime;
        
        return aTimeAdjusted.diff(bTimeAdjusted);
    });
	return pausen;
}

// Springt zum nächsten Input Element nach Eingabe
function jumpNext(thisElement, nextElement, event) {
	event.stopPropagation();
	if (oldFocus === null) oldFocus = thisElement;
	if (oldFocus !== null && oldFocus !== thisElement) {
		keysPressedCount = 0;
		oldFocus = thisElement;
	}
	if (event.key === 'Backspace') {
		keysPressedCount = Math.max(keysPressedCount - 1, 0);
	}
	if (event.key === 'Tab') {
		keysPressedCount = 0;
	}
	// Nur zählen, wenn es eine Nummer war
	if (!Number.isNaN(parseInt(event.key, 10))) {
		keysPressedCount += 1;
	}

	if (keysPressedCount === 4) {
		document.querySelector(`[aria-label='${nextElement}']`).focus();
		keysPressedCount = 0;
	}
}

function resetKeysPressedCount() {
	keysPressedCount = 0;
}

// Verhindere, dass Enter sehr viele Schichten auf einmal erstellt bei gedrückthalten der Enter Taste
const updateThrottleEnter = throttle(() => {
	inputZeiten(false);
}, 100);

// Initialisierung der Schichterstellung durch Enter-Taste
function enterElement() {
	updateThrottleEnter();
}

// Führt die Funktion des callbacks in einem bestimmten Delay intervall aus, damit nicht gespammt wird
function throttle(cb, delay = 1000) {
	let shouldWait = false;
	let waitingArgs;
	const timeoutFunc = () => {
		if (waitingArgs == null) {
			shouldWait = false;
		} else {
			cb(...waitingArgs);
			waitingArgs = null;
			setTimeout(timeoutFunc, delay);
		}
	};

	return (...args) => {
		if (shouldWait) {
			waitingArgs = args;
			return;
		}

		cb(...args);
		shouldWait = true;

		setTimeout(timeoutFunc, delay);
	};
}

function resetDeleteIndices() {
	schichtenIndex = null;
	deleteStartIndex = null;
}

// Wir markieren die Schichten, die wir löschen wollen in rot
function markiereSchichtenLoeschen(event) {
	const schichten = Array.from(document.querySelectorAll('.zeiten-grid:not(#zeiten-grid-legende)'));

	// Falls es keine Schichten gibt, machen wir nix.
	if (schichten.length <= 0) {
		resetDeleteIndices();
		return;
	}

	// Falls eine Schicht selektiert ist, starten wir hier.
	if (schichtSelected !== null) {
		const tempSelection = document.getElementById(schichtSelected);
		tempSelection.classList.add('zeiten-item-loeschen');
		schichtenIndex = schichten.indexOf(tempSelection);
		deleteStartIndex = schichtenIndex;
		removeSchichtSelection();
		return;
	}
	// Falls wir noch keinen Ausgangspunkt haben, verwenden wir das erste Element
	if (event.key === 'ArrowDown' && schichtenIndex === null) {
		schichtenIndex = 0;
		deleteStartIndex = schichtenIndex;
		schichten[schichtenIndex].classList.add('zeiten-item-loeschen');
		removeSchichtSelection();
		return;
	}

	// Falls wir noch keinen Ausgangspunkt haben, verwenden wir das letzte Element
	if (event.key === 'ArrowUp' && schichtenIndex === null) {
		schichtenIndex = schichten.length - 1;
		deleteStartIndex = schichtenIndex;
		schichten[schichtenIndex].classList.add('zeiten-item-loeschen');
		removeSchichtSelection();
		return;
	}

	if (event.key === 'ArrowUp') {
		// ArrowUp:
		schichtenIndex = Math.max(schichtenIndex - 1, -1);
		// Falls wir out-of-bounds geraten würden, machen wir nix und reseten auf den ersten Index!
		if (schichtenIndex === -1) {
			schichtenIndex = 0;
			return;
		}
		// markiere wenn der schichtindex oberhalb (kleiner) des startindex ist.
		if (schichtenIndex < deleteStartIndex) {
			schichten[schichtenIndex].classList.add('zeiten-item-loeschen');
		} else if (schichtenIndex + 1 < schichten.length) schichten[schichtenIndex + 1].classList.remove('zeiten-item-loeschen');
	} else {
		// ArrowDown:
		schichtenIndex = Math.min(schichtenIndex + 1, schichten.length);
		// Falls wir out-of-bounds geraten würden, machen wir nix und resetten auf den letzten Index!
		if (schichtenIndex === schichten.length) {
			schichtenIndex = schichten.length - 1;
			return;
		}
		// markiere wenn der schichtindex oberhalb (kleiner) des startindex ist.
		if (schichtenIndex > deleteStartIndex) {
			schichten[schichtenIndex].classList.add('zeiten-item-loeschen');
		} else if (schichtenIndex - 1 >= 0) {
			schichten[schichtenIndex - 1].classList.remove('zeiten-item-loeschen');
		}
	}
}

// Aufhebung der Löschmarkierungen
function unmarkiereSchichtenLoeschen() {
	const markierteSchichten = document.querySelectorAll('.zeiten-item-loeschen');
	markierteSchichten.forEach((schicht) => {
		schicht.classList.remove('zeiten-item-loeschen');
		resetDeleteIndices();
	});
}

// Markierung aller Schichten zum Löschen
function markiereAlleSchichtenLoeschen() {
	const schichten = Array.from(document.querySelectorAll('.zeiten-grid:not(#zeiten-grid-legende)'));
	schichten.forEach((schicht) => {
		schicht.classList.add('zeiten-item-loeschen');
	});
}



// Lese Request einer bestimmten Schicht
async function clickLeseSchicht(schichtID) {
	const schicht = await schichtService.leseSchicht(schichtID);
	if (!_.isEmpty(schicht)) {
		await fuelleSchichtBalken(schicht);
		return schicht;
	}
	return false;
}

/**
 * Trägt mehrere Schichten ein mit EGFZ und Sollzeiten, z.B. für Urlaub
 * @param {numberString} egfzID bestimmt den EGFZ Typ, hier: 2: Urlaub, 3: Krank, 4: Schule, 23: Kurzarbeit
 */
async function inputEgfzTage(egfzID) {
	egfzID = parseInt(egfzID, 10);
	if (!egfzID) {
		return;
	}

	let datumVon = document.querySelector('#input-von').value;
	let datumBis = document.querySelector('#input-bis').value;
	const validInput = checkValidEgfzTageInput(datumVon, datumBis);
	if (!validInput) return;
	// URLAUB wird separat erstellt
	let result = false;
	if (egfzID === 2) {
		result = await inputEgfzTageUrlaub(datumVon, datumBis);
	} else {
		result = await inputEgfzTageStandard(datumVon, datumBis, egfzID);
	}
	// Zeiten neu Laden bei Erfolg
	if (result) {
		await zeitenScript();
	}
}

/**
 * Bereitet die aktuelle Auswahl an Daten für die Serveranfrage vor.
 * @param {*} datumVon 
 * @param {*} datumBis 
 * @param {*} egfzID 
 * @returns 
 */
async function inputEgfzTageStandard(datumVon, datumBis, egfzID) {
	// Auswahl an Qualifikation und Posten übergeben
	const qualiSelect = document.body.querySelector('[aria-label="zeiten-QualifikationID"]');
	const postenSelect = document.body.querySelector('[aria-label="zeiten-PostenID"]');
	if (!qualiSelect.options[qualiSelect.selectedIndex]) {
		systemNachrichtService.zeigeKleineNachricht('Mitarbeiter besitzt noch keine Qualifikation!', 0);
		return;
	}
	if (!postenSelect.options[postenSelect.selectedIndex]) {
		systemNachrichtService.zeigeKleineNachricht('Mitarbeiter ist noch keinem Posten zugeordnet!', 0);
		return;
	}
	const QualifikationID = qualiSelect.value;
	const PostenID = postenSelect.value;
	const inputObject = {
		MitarbeiterID: stammdatenService.aktuellerMitarbeiter._id,
		DatumVon: datumVon,
		DatumBis: datumBis,
		EgfzID: egfzID,
		PostenID,
		QualifikationID,
	};

	const result = await schichtService.erstelleEgfzTage(inputObject);
	return result;
}

/**
 * Erstellt Urlaubsschichten inklusive Urlaubsantrag
 * @param {String} datumVon YYYY-MM-DD
 * @param {String} datumBis YYYY-MM-DD
 */
async function inputEgfzTageUrlaub(datumVon, datumBis) {
	const urlaubsKollisionIndex = checkUrlaubsantragKollisionen(stammdatenService.aktuellerMitarbeiter, datumVon, datumBis);
		if (urlaubsKollisionIndex >= 0) {
			await SystemDialogService.instance.displayAsync('zeiten-urlaub-kollision-dialog');
			return;
		}
		const result = await schichtService.erstelleUrlaubsschichten(stammdatenService.aktuellerMitarbeiter._id, datumVon, datumBis);
		return result;
}

function checkValidEgfzTageInput(datumVon, datumBis) {
	if (datumVon === '' || datumBis === '') {
		const dialogText = 'Bitte von und bis Datum angeben!';
		systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
		return false;
	}
	
	if (datumBis < datumVon) {
		const dialogText = 'Das bis Datum muss nach dem von Datum liegen!';
		systemNachrichtService.zeigeKleineNachricht(dialogText, -1);
		return false;
	}
	const maEintritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Eintrittsdatum;
	const maAustritt = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0].Austrittsdatum;
	// Ohne Eintrittsdatum wird kein Schichteninput erlaubt...
	if (_.isEmpty(maEintritt)) {
		systemNachrichtService.zeigeKleineNachricht('Bitte erst das Eintrittsdatum der Beschäftigung festlegen!', 0);
		return false;
	}
	// Falls der user eine Schicht vor dem Eintrittsdatum des Mitarbeiters eingeben will, wird dies geblockt.
	if (datumVon < maEintritt) {
		systemNachrichtService.zeigeKleineNachricht('Schichtdatum darf nicht vor Eintrittsdatum liegen!', -1);
		return false;
	}
	// Falls der user eine Schicht nach dem Austrittsdatum des Mitarbeiters eingeben will, wird dies geblockt.
	if (maAustritt && (datumVon > maAustritt || datumBis > maAustritt)) {
		systemNachrichtService.zeigeKleineNachricht('Schichtdatum darf nicht nach dem Austrittsdatum liegen!', -1);
		return false;
	}
	return true;
}

function berechneEgfzTageAnzahl() {
	let datumVon = document.querySelector('#input-von').value;
	let datumBis = document.querySelector('#input-bis').value;
	if (datumVon === '' || datumBis === '') {
		document.body.querySelector('[aria-label="egfz-gesamt"]').value = '';
		return;
	}

	if (datumBis < datumVon) {
		document.body.querySelector('[aria-label="egfz-gesamt"]').value = '';
		return;
	}
	const mitarbeiterBeschaeftigung = stammdatenService.aktuellerMitarbeiter.Beschaeftigung[0];
	const regeltage = mitarbeiterBeschaeftigung.Regelarbeitstage;
	const hatRegelarbeitstage = regeltage.some((zeit) => zeit);
	const tageAnzahl = dayjs.tz(datumBis, dayjs.tz.DEFAULT_TZ).diff(dayjs.tz(datumVon, dayjs.tz.DEFAULT_TZ), 'day');
	let tageCounter = 0;
	let tmpDate = dayjs.tz(datumVon, dayjs.tz.DEFAULT_TZ);
	for (let i = 0; i <= tageAnzahl; i += 1) {
		tmpDate.add(i, 'day');
		// Montag ist der Tag im Index 0 und Sonntag der letzte also Index 6.
		const wochentagIndex = tmpDate.day() === 0 ? 6 : tmpDate.day() - 1;
		// Wir stellen zählen nur, falls es ein Regelarbeitstag ist...
		const tagDiff = mitarbeiterBeschaeftigung.SolltageWoche - (i % 7);
		if ((hatRegelarbeitstage && regeltage[wochentagIndex]) || (!hatRegelarbeitstage && tagDiff > 0)) {
			tageCounter += 1;
		}
	}
	document.body.querySelector('[aria-label="egfz-gesamt"]').value = tageCounter;
}

async function monatlicheGutzeitMA() {
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
	await schichtService.erstelleMonatlicheGutzeitMA(stammdatenService.aktuellerMitarbeiter._id, zeitraum);
	zeitenScript(true); // erzwinge reload
}

async function arbeitszeitenVormonat() {
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD'); // aktueller Monat, vormonat wird im Service berechnet
	await schichtService.kopiereArbeitszeitenVormonat(stammdatenService.aktuellerMitarbeiter._id, zeitraum);
	zeitenScript(true); // erzwinge reload
}

async function regelarbeitszeitenAnwenden() {
	const zeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD'); // aktueller Monat
	await schichtService.erstelleRegelarbeitszeitenMonat(stammdatenService.aktuellerMitarbeiter._id, zeitraum);
	zeitenScript(true); // erzwinge reload
}

function toggleStempelZeiten(event) {
	document.getElementById('zeiten-liste').classList.toggle('show-stempelzeiten', event.target.checked);
}

export default zeitenScript;
